"use client";

import React from "react";
import { Separator } from "@/components/ui/separator";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const partners = [{
  name: "Malaysian Bar",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1662932/img/malaysian_bar_logo.png"
}, {
  name: "Industrial Court of Malaysia",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1662932/img/industrial_court_logo.png"
}, {
  name: "Selangor Bar Committee",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1662932/img/selangor_bar_logo.png"
}, {
  name: "Legal Aid Centre",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1662932/img/legal_aid_logo.png"
}, {
  name: "Human Resources Development Fund",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1662932/img/hrdf_malaysia_logo.png"
}, {
  name: "Chartered Institute of Arbitrators",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1662932/img/ciarb_logo.png"
}];
export default function OurPrestigePartners() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="222007" id="professional-affiliations" className="bg-background text-foreground py-16 md:py-24 w-full overflow-hidden">
      
    </section>;
}